export const currency = '$'
